export default "__VITE_ASSET__D7K8HQpO__"